import { useCallback, useEffect, useState } from 'react';

/**
 * Document fullscreen for the standalone embed page (React port of
 * FullScreenController in embed.v4.fullscreen.js): report support so the header
 * can gate its toggle, track the live state so the icon can flip expand↔compress,
 * and toggle the whole embed document in/out of fullscreen. When the embed is
 * itself iframed, the parent frame must carry `allowfullscreen` (the frozen PHP
 * shell already does); this only drives the embed's own document.
 */
export function useFullscreen() {
   const supported =
      typeof document !== 'undefined' &&
      typeof document.documentElement.requestFullscreen === 'function';

   const [isFullscreen, setIsFullscreen] = useState(false);

   useEffect(() => {
      const onChange = () => setIsFullscreen(Boolean(document.fullscreenElement));
      document.addEventListener('fullscreenchange', onChange);
      return () => document.removeEventListener('fullscreenchange', onChange);
   }, []);

   const toggle = useCallback(() => {
      if (document.fullscreenElement) {
         void document.exitFullscreen();
      } else {
         void document.documentElement.requestFullscreen();
      }
   }, []);

   return { supported, isFullscreen, toggle };
}
